import { render, staticRenderFns } from "./ListAgeGroupReport.vue?vue&type=template&id=a98cb1ac&scoped=true"
import script from "./ListAgeGroupReport.vue?vue&type=script&lang=js"
export * from "./ListAgeGroupReport.vue?vue&type=script&lang=js"
import style0 from "./ListAgeGroupReport.vue?vue&type=style&index=0&id=a98cb1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98cb1ac",
  null
  
)

export default component.exports